import './main.less';

import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';
import { Link } from 'react-router';

class Main extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isActive: false
		};
	}

	render() {
		return (
			<div
				className={cn({
					'menu-hamburger': true,
					'hamburger': true,
					'hamburger--spin': true,
					'is-active': this.props.isHamburgerActive
				})}
				tabIndex='0'
				aria-label='Menu'
				role='button'
				aria-controls='navigation'
				onClick={this.props.handleHamburgerClick}
			>
				<span className='hamburger-box'>
					<span className='hamburger-inner'></span>
				</span>
				<div className='hamburger__title'>{this.props.intl('Menu')}</div>

				<div className='hamburger__navigation'>
					{this.props.navbarMenu.map(menu => menu.isLink
						? <Link key={menu.title} className={`navbar__item ${menu.activeClass}`} to={menu.to} >
							{this.props.intl(menu.title)}</Link>
						: <a key={menu.title}  className={`navbar__item ${menu.activeClass}`} href={menu.to}>
							{this.props.intl(menu.title)}</a>
					)}
				</div >
			</div>
		);
	}
}

Main.propTypes = {
	intl: PropTypes.func,
	navbarMenu: PropTypes.array,
	isHamburgerActive: PropTypes.bool,
	handleHamburgerClick: PropTypes.func
};

export default Main;


// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/market/components/hamburger/main.js